import React, { ReactElement } from 'react';
import Head from 'next/head';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Event from 'components/Event';
import { withAuth } from 'lib/hocs/withAuth';

import styles from './CreateEvent.module.scss';

const CreateEvent = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Create a new event | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <section className={styles.CreateEvent} data-testid="CreateEvent">
        <Event isSocietyEvent={true} />
      </section>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'opportunity.posting',
      ])),
    },
  };
}

const CreateEventWrapper = withAuth(CreateEvent);

export default CreateEventWrapper;
